/**
 * libraryRowLines.js — story 167 (HU-04 · RN-06.6, RN-06.7, D13/DL-18, D16.3). Pure.
 * First line: the name, or the code when there is no name. Second line: the code as it comes (unless it is
 * already on the first line), the version and what it lasts, separated by " · ".
 */
const SEPARATOR = ' · '

const joinLine = (parts) => parts.filter((part) => part !== '').join(SEPARATOR)

/** A template version 2.0 reads "v2", 1.5 reads "v1.5"; no version, no label. */
export const versionLabelOf = (version) => (version === null || version === undefined || version === '' ? '' : 'v' + String(Number(version)))

export const processRowLines = (process, durationText = '') => {
  const name = process?.name || ''
  const code = process?.code || ''
  return { primary: name || code, secondary: joinLine([name ? code : '', versionLabelOf(process?.version), durationText]) }
}

/**
 * D16.3: a LINKED operation shows the code of its library operation and its version; a local one, the code of
 * its node and no version; a subprocess, its code and no version (P1 does not publish it).
 */
export const processTreeRowLines = (row, durationText = '') => {
  const shownCode = row.linked ? row.operationCode : row.code
  const version = row.linked ? versionLabelOf(row.operationVersionNumber) : ''
  return { primary: row.name || shownCode, secondary: joinLine([row.name ? shownCode : '', version, durationText]) }
}

/**
 * Story 184 (CA1 · RN-01.1, RN-01.2): the operation row no longer repeats the version here — the `vN ▾` control
 * on its right is the only place that shows it. Second line: the code (unless it is already the first line)
 * and what it lasts.
 */
export const operationRowLines = (item, durationText = '') => {
  const name = item?.name || ''
  const code = item?.code || ''
  return { primary: name || code, secondary: joinLine([name ? code : '', durationText]) }
}
